export const getRoomName = (turnoId: number, medicoNombre: string, pacienteNombre: string) => {

	const medicoCuatro = medicoNombre.substring(0, 4)
	const pacienteCuatro = pacienteNombre.substring(0, 4)
	const turnoMinimo4 = `${turnoId}${turnoId+4}${turnoId-1}${turnoId+7}${turnoId+9}${turnoId+3}${turnoId+2}${turnoId-5}`
	const turnoOcho = turnoMinimo4.substring(0, 4)
	const todayString = new Date().toISOString().split('T')[0]

	return `ksandrax${turnoOcho}${medicoCuatro}${pacienteCuatro}${todayString}`
}